import { webAnalytics as wa } from '@principal/web-analytics';
import useSavedSearches from '../../hooks/useSavedSearches';
import SavedSearch from '../../models/SavedSearch';
import {
  useAdvancedSearchCriteriaUpdater,
  useAdvancedSearchOptions,
  useTriggerAdvancedSearch,
} from '../../hooks/useAdvancedSearchCriteria';
import useDeleteSavedSearch from '../../hooks/useDeleteSavedSearch';
import { useHubTab } from '../../../shared/hooks/useHubTab';
import { SearchType } from '../../../shared/models/WebAnalytics';
import { getSelectedAdvancedSearchFilterLabels } from '../../../util/analyticsEventHelpers';

const SavedSearchListItems = () => {
  const { data: savedSearches } = useSavedSearches();
  const updateSearchCriteria = useAdvancedSearchCriteriaUpdater();
  const searchOptions = useAdvancedSearchOptions();
  const { toggleTriggerAdvancedSearch } = useTriggerAdvancedSearch();
  const hubTab = useHubTab();
  const [deleteById] = useDeleteSavedSearch();

  const onSavedSearchClick = (savedSearch: SavedSearch, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    wa.trackEvent('pageNavigationClick', {
      clicktext: `${hubTab}-${SearchType.ADVANCED_SEARCH}-Apply Saved Search-${getSelectedAdvancedSearchFilterLabels(
        savedSearch.searchCriteria,
        searchOptions,
      )}`,
      navigationsection: 'call-to-action',
    });

    updateSearchCriteria(savedSearch.searchCriteria);
    toggleTriggerAdvancedSearch(true);
  };

  const onDeleteSearchClick = async (id: string, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    wa.trackEvent('pageNavigationClick', {
      clicktext: `${hubTab}-${SearchType.ADVANCED_SEARCH}-Delete Saved Search`,
      navigationsection: 'call-to-action',
    });
    await deleteById(id);
  };

  if (savedSearches === undefined) {
    return <div />;
  }

  return (
    <>
      <li className="dropdown-header">Apply Saved Search</li>
      {savedSearches.map((s) => (
        <li key={s.id}>
          <button
            type="button"
            className="btn btn-link btn-link-inline text-muted pull-right"
            onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => onDeleteSearchClick(s.id, event)}
            aria-label="Delete saved search"
          >
            <i className="fa fa-trash" />
          </button>
          <a
            href="# "
            onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => onSavedSearchClick(s, event)}
          >
            {s.title}
          </a>
        </li>
      ))}
    </>
  );
};

export default SavedSearchListItems;
